import { AiReply } from '@/types/reply';
import { I18nFullLanguage } from '@/utils/i18n';

import AppApi from './app-api';

export type AiReplyRequestBody = {
  content: string;
  rating_recommend: number;
  shops_name: string;
  reviewer: string;
};

export type AiReplyRequestBodyInternational = AiReplyRequestBody & {
  language: I18nFullLanguage;
};

export type AiReplyResponse = {
  content: string;
};

export class AiReplyApi {
  constructor(private api: AppApi) {}

  async postV1(body: AiReplyRequestBody): Promise<AiReplyResponse> {
    const res = await this.api.INSTANCE.post(`/ai-replies/v1`, body);
    return res.data;
  }

  async postV1International(body: AiReplyRequestBodyInternational): Promise<AiReplyResponse> {
    const res = await this.api.INSTANCE.post(`/ai-replies/v1/international`, body);
    return res.data;
  }

  async postV2(body: AiReplyRequestBody): Promise<AiReplyResponse> {
    const res = await this.api.INSTANCE.post(`/ai-replies/v2`, body);
    return res.data;
  }

  async postGPT(body: AiReplyRequestBody): Promise<AiReplyResponse> {
    const res = await this.api.INSTANCE.post(`/ai-replies/gpt`, body);
    return res.data;
  }

  async getAiRepliesMultiple(rating: number): Promise<AiReplyResponse[]> {
    const res = await this.api.INSTANCE.get(`/ai-replies/v1/multiple`, {
      params: { rating },
    });
    return res.data;
  }

  async getSampleAiReplyWithShopIds(shopIds: string[]): Promise<AiReply> {
    const res = await this.api.INSTANCE.post('/ai-replies/samples', {
      shop_ids: shopIds,
      // option: 'random',
      option: 'recent',
    });

    return res.data as AiReply;
  }
}
